import { gql } from "@apollo/client";export default gql`mutation deleteContent($id: Int!) {
    deleteContent: delete_collection_content_by_pk(id: $id) {
        id
    }
}
`;
